// extracted by mini-css-extract-plugin
export default {"resendButton":"MyCoachingPopup_resendButton__nNzBt","spinner":"MyCoachingPopup_spinner__jKy-f","error":"MyCoachingPopup_error__CHu5Q","content":"MyCoachingPopup_content__7Gcrw"};